import { z } from 'zod';
import { emailSchema } from '../common/email.js';
import { firstNameSchema } from '../common/first-name.js';
import { lastNameSchema } from '../common/last-name.js';
import { countryCodeSchema, phoneNumberSchema, validatePhone } from '../common/phone-number.js';
import { streetAddressSchema } from '../common/street-address.js';
import { inquiryPropertyTypeEnum } from './property-type.js';
export const inquirySellOccupancyConditionEnum = {
    OWNER_OCCUPIED: 'Owner Occupied',
    LEASED: 'Leased With Tenant in Place',
    VACANT_AS_IS: 'Vacant Property, As Is',
    VACANT_RENOVATED: 'Vacant Property, Renovated',
};
export const inquirySellPropertySchema = z
    .object({
    first_name: firstNameSchema,
    last_name: lastNameSchema,
    email: emailSchema,
    phone_number: phoneNumberSchema,
    phone_number_country_code: countryCodeSchema,
    property_address: streetAddressSchema,
    property_type: z.enum(inquiryPropertyTypeEnum).meta({ field: 'select' }),
    occupancy_condition: z
        .enum(inquirySellOccupancyConditionEnum)
        .meta({ field: 'select', label: 'Occupancy/Condition' }),
})
    .superRefine((data, ctx) => {
    validatePhone(ctx, 'phone_number', data.phone_number, data.phone_number_country_code);
});
